/* Techniques product page: variant picking and add to bag via the theme's cart drawer. */
(() => {
  document.querySelectorAll('.tc-pdp').forEach((root) => {
    const form = root.querySelector('.tc-pdp__form');
    const variants = JSON.parse(root.querySelector('[data-tc-variants]').textContent);
    const input = root.querySelector('[data-tc-variant-input]');
    const addBtn = root.querySelector('[data-tc-add]');
    const addLabel = root.querySelector('[data-tc-add-label]');
    const priceEl = root.querySelector('[data-tc-price]');
    const skuEl = root.querySelector('[data-tc-sku]');
    const stockEl = root.querySelector('[data-tc-stock]');
    const errorEl = root.querySelector('[data-tc-error]');
    const groups = [...root.querySelectorAll('[data-tc-option]')];
    const sticky = root.querySelector('[data-tc-sticky]');
    const stickyAdd = root.querySelector('[data-tc-sticky-add]');
    const stickyPrice = root.querySelector('[data-tc-sticky-price]');
    const stickyOpt = root.querySelector('[data-tc-sticky-opt]');
    const money = (cents, plain) => Tc.money(cents, plain);
    const selected = () => groups.map((g) => (g.querySelector('input:checked') || {}).value);

    const markAvailability = () => {
      const sel = selected();
      groups.forEach((g, gi) => {
        g.querySelectorAll('.tc-opt__input').forEach((inp) => {
          const test = sel.slice(); test[gi] = inp.value;
          const match = variants.find((v) => v.options.every((o, i) => o === test[i]));
          inp.nextElementSibling.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    };

    const render = (v) => {
      if (!v) {
        addBtn.disabled = true; addLabel.textContent = 'Unavailable';
        return;
      }
      input.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (stockEl) stockEl.textContent = v.available ? 'In stock' : 'Sold out';
      if (skuEl) skuEl.textContent = v.sku || '';
      if (priceEl) {
        priceEl.innerHTML = v.compare_at_price > v.price
          ? `<span class="tc-price tc-price--sale">${money(v.price)}</span><s class="tc-price tc-price--was">${money(v.compare_at_price, true)}</s><span class="tc-price__tag tc-eyebrow">-${Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price)}%</span>`
          : `<span class="tc-price">${money(v.price)}</span>`;
      }
      if (stickyAdd) { stickyAdd.disabled = !v.available; stickyAdd.textContent = v.available ? 'Add to bag' : 'Sold out'; }
      if (stickyPrice) stickyPrice.innerHTML = money(v.price);
      if (stickyOpt) stickyOpt.textContent = v.title;
      const url = new URL(location.href); url.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', url);
      if (v.featured_media) {
        const frame = root.querySelector(`[data-media-id="${v.featured_media.id}"]`);
        const track = root.querySelector('[data-tc-track]');
        if (frame && track && window.matchMedia('(max-width: 989px)').matches) track.scrollTo({ left: frame.offsetLeft, behavior: 'smooth' });
      }
    };

    groups.forEach((g, gi) => g.addEventListener('change', () => {
      const sel = selected();
      const valueEl = g.querySelector('[data-tc-option-value]');
      if (valueEl) valueEl.textContent = sel[gi];
      render(variants.find((v) => v.options.every((o, i) => o === sel[i])));
      markAvailability();
    }));
    markAvailability();

    // Sticky add-to-bag: visible once the main button has scrolled away
    const actions = root.querySelector('.tc-pdp__actions');
    if (sticky && actions && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        const show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', show);
        sticky.setAttribute('aria-hidden', String(!show));
        if (stickyAdd) stickyAdd.tabIndex = show ? 0 : -1;
      }).observe(actions);
      stickyAdd && stickyAdd.addEventListener('click', () => addBtn.click());
    }

    // Review stars jump to the reviews section
    const top = root.querySelector('.tc-pdp__app--top');
    if (top) top.addEventListener('click', (e) => {
      const target = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
      if (!target) return;
      e.preventDefault(); e.stopPropagation();
      const y = target.getBoundingClientRect().top + window.scrollY - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 64) - 16;
      window.scrollTo({ top: y, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }, true);

    // Phone gallery: arrows, counter, progress; the collage steps one group (1 large + 2 small) at a time
    const track = root.querySelector('[data-tc-track]');
    const count = root.querySelector('[data-tc-count]');
    const countTotal = root.querySelector('[data-tc-count-total]');
    const gprev = root.querySelector('[data-tc-gprev]');
    const gnext = root.querySelector('[data-tc-gnext]');
    const gbar = root.querySelector('[data-tc-gbar]');
    if (track) {
      const frames = [...track.children];
      const collage = () => track.classList.contains('tc-pdp__track--collage') && getComputedStyle(track).display === 'grid';
      const anchors = () => (collage() ? frames.filter((f, i) => i % 3 === 0) : frames);
      const current = () => {
        const a = anchors(); let best = 0, d = Infinity;
        a.forEach((f, i) => { const x = Math.abs(f.offsetLeft - track.scrollLeft); if (x < d) { d = x; best = i; } });
        return best;
      };
      const syncG = () => {
        const a = anchors(); const i = current();
        const max = track.scrollWidth - track.clientWidth;
        const p = max > 0 ? track.scrollLeft / max : 0;
        if (count) {
          if (collage()) { const from = i * 3 + 1, to = Math.min(i * 3 + 3, frames.length); count.textContent = from === to ? String(from) : from + '-' + to; }
          else count.textContent = String(i + 1);
        }
        if (countTotal) countTotal.textContent = frames.length;
        if (gprev) gprev.disabled = p <= 0.01;
        if (gnext) gnext.disabled = p >= 0.99 || a.length < 2;
        if (gbar) gbar.parentElement.style.setProperty('--p', Math.max(p, 1 / Math.max(a.length, 1)).toFixed(3));
      };
      const go = (dir) => {
        const a = anchors(); const i = Math.min(Math.max(current() + dir, 0), a.length - 1);
        track.scrollTo({ left: a[i].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      if (gprev) gprev.addEventListener('click', () => go(-1));
      if (gnext) gnext.addEventListener('click', () => go(1));
      track.addEventListener('scroll', () => requestAnimationFrame(syncG), { passive: true });
      window.addEventListener('resize', syncG);
      syncG();

      // Tap a photo or video on phones to open the full-screen viewer
      const lb = root.querySelector('[data-tc-lightbox]');
      const lbTrack = root.querySelector('[data-tc-lb-track]');
      const lbCount = root.querySelector('[data-tc-lb-count]');
      if (lb && lbTrack) {
        let releaseViewer, closeTimer;
        const big = (img) => (img.currentSrc || img.src).replace(/([?&])width=\d+/, '$1width=1800');
        // Shopify's video_tag nests a still <img> inside <video>, so look for the video first
        const items = frames.filter((f) => f.querySelector('video, img'));
        const esc = (t) => String(t || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;');
        const slide = (f) => {
          const v = f.querySelector('video');
          if (v) {
            const sources = [...v.querySelectorAll('source')].map((s) => '<source src="' + esc(s.getAttribute('src')) + '"' + (s.type ? ' type="' + esc(s.type) + '"' : '') + '>').join('');
            return '<div class="tc-lightbox__slide tc-lightbox__slide--video"><video muted loop playsinline controls preload="metadata"' + (v.poster ? ' poster="' + esc(v.poster) + '"' : '') + '>' + sources + '</video></div>';
          }
          const im = f.querySelector('img');
          return '<div class="tc-lightbox__slide"><img src="' + big(im) + '" alt="' + esc(im.alt) + '"></div>';
        };
        // Only the slide on screen plays
        const playActive = (idx) => lbTrack.querySelectorAll('video').forEach((v) => {
          if (v.closest('.tc-lightbox__slide') === lbTrack.children[idx]) { if (v.paused) v.play().catch(() => {}); }
          else if (!v.paused) v.pause();
        });
        const openLb = (startIdx, trigger) => {
          clearTimeout(closeTimer);
          lbTrack.innerHTML = items.map(slide).join('');
          lb.hidden = false; requestAnimationFrame(() => lb.classList.add('is-open'));
          lb.inert = false;
          lbTrack.scrollLeft = lbTrack.clientWidth * startIdx;
          const upd = () => {
            const idx = Math.round(lbTrack.scrollLeft / lbTrack.clientWidth);
            if (lbCount) lbCount.textContent = (idx + 1) + ' / ' + items.length;
            playActive(idx);
          };
          lbTrack.onscroll = () => requestAnimationFrame(upd); upd();
          releaseViewer = Tc.modal(lb, trigger, lb.querySelector('[data-tc-lb-close]'));
        };
        const closeLb = () => {
          if (lb.hidden || lb.inert) return;
          lbTrack.querySelectorAll('video').forEach((v) => v.pause());
          lb.classList.remove('is-open'); lb.inert = true;
          releaseViewer?.(); releaseViewer = null;
          closeTimer = setTimeout(() => { lb.hidden = true; lbTrack.innerHTML = ''; }, 350);
        };
        lb.querySelector('[data-tc-lb-close]').addEventListener('click', closeLb);
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !lb.hidden) closeLb(); });
        frames.forEach((f, i) => {
          if (!items.includes(f)) return;
          const activate = () => {
            if (!matchMedia('(max-width: 989px)').matches) return;
            openLb(items.indexOf(f), f);
          };
          const access = () => {
            const phone = matchMedia('(max-width: 989px)').matches;
            f.tabIndex = phone ? 0 : -1;
            if (phone) { f.setAttribute('role', 'button'); f.setAttribute('aria-label', root.dataset.photoLabel.replace('[number]', i + 1)); }
            else { f.removeAttribute('role'); f.removeAttribute('aria-label'); }
          };
          access(); window.addEventListener('resize', access);
          f.addEventListener('click', activate);
          f.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); } });
        });
      }
    }

    // Add to bag
    form.addEventListener('submit', async (e) => {
      if (e.submitter && e.submitter !== addBtn) return; // let express checkout through
      e.preventDefault();
      errorEl.hidden = true;
      addBtn.classList.add('is-loading');
      try {
        const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(input.value), quantity: 1 }], sections: 'cart-drawer,header-cart-status', sections_url: location.pathname })
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add this item.');
        const swap = (sectionId, selector) => {
          const html = data.sections && data.sections[sectionId];
          const target = document.querySelector(selector);
          if (!html || !target) return false;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector(selector) || doc.querySelector('.shopify-section') || doc.body;
          if (fresh) { target.innerHTML = fresh.innerHTML; return true; }
          return false;
        };
        swap('header-cart-status', '#headerCartStatus');
        const drawerUpdated = swap('cart-drawer', '#cartDrawer');
        addBtn.classList.add('is-added');
        setTimeout(() => addBtn.classList.remove('is-added'), 1400);
        TcCart.refreshCount();
        if (window.Assortion?.cart?.id === 'assortion' || drawerUpdated) await TcCart.open(addBtn);
        else window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
      } catch (err) {
        errorEl.textContent = err.message; errorEl.hidden = false;
      } finally {
        addBtn.classList.remove('is-loading');
      }
    });
  });
})();
